// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"DetailsFooter__wrapper__Jedcz","quoteWrapper":"DetailsFooter__quoteWrapper__2iLG6 DetailsFooter__wrapper__Jedcz","quoteWrapperNoQuotes":"DetailsFooter__quoteWrapperNoQuotes__22p2z DetailsFooter__quoteWrapper__2iLG6 DetailsFooter__wrapper__Jedcz","noQuotes":"DetailsFooter__noQuotes__11LFK DetailsFooter__quoteWrapper__2iLG6 DetailsFooter__wrapper__Jedcz","somewhereElse":"DetailsFooter__somewhereElse__1kTE3","customsWrapper":"DetailsFooter__customsWrapper__1RFMt DetailsFooter__wrapper__Jedcz"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Shipping/ShippingDetailsModal/DetailsFooter.scss
// module id = 1721
// module chunks = 4 14